/* eslint-disable sonarjs/no-duplicate-string */

type Subject = {
  subject: string;
  urlSubject: string;
};

type Level = {
  level: string;
  urlLevel: string;
  subjects: Subject[];
};

export type StaticLevelsData = Level[];

export const staticLevelsData: StaticLevelsData = [
  {
    level: "A Level",
    urlLevel: "A-Level",
    subjects: [
      {
        subject: "Accounting",
        urlSubject: "Accounting",
      },
      {
        subject: "Arabic",
        urlSubject: "Arabic",
      },
      {
        subject: "Art",
        urlSubject: "Art",
      },
      {
        subject: "Biology",
        urlSubject: "Biology",
      },
      {
        subject: "Business Studies",
        urlSubject: "Business-Studies",
      },
      {
        subject: "Career Development",
        urlSubject: "Career-Development",
      },
      {
        subject: "Chemistry",
        urlSubject: "Chemistry",
      },
      {
        subject: "Classical Civilisation",
        urlSubject: "Classical-Civilisation",
      },
      {
        subject: "Classical Greek",
        urlSubject: "Classical-Greek",
      },
      {
        subject: "Computer Science",
        urlSubject: "ComputerScience",
      },
      {
        subject: "Design & Technology",
        urlSubject: "Design-and-Technology",
      },
      {
        subject: "Drama",
        urlSubject: "Drama",
      },
      {
        subject: "Dutch",
        urlSubject: "Dutch",
      },
      {
        subject: "Economics",
        urlSubject: "Economics",
      },
      {
        subject: "Electronics",
        urlSubject: "Electronics",
      },
      {
        subject: "English",
        urlSubject: "English",
      },
      {
        subject: "English and World Literature",
        urlSubject: "English-and-World-Literature",
      },
      {
        subject: "English Language",
        urlSubject: "English-Language",
      },
      {
        subject: "English Literature",
        urlSubject: "English-Literature",
      },
      {
        subject: "Environmental Studies",
        urlSubject: "Environmental-Studies",
      },
      {
        subject: "Extended Project Qualification",
        urlSubject: "EPQ",
      },
      {
        subject: "French",
        urlSubject: "French",
      },
      {
        subject: "Further Mathematics",
        urlSubject: "Further-Maths",
      },
      {
        subject: "Geography",
        urlSubject: "Geography",
      },
      {
        subject: "Geology",
        urlSubject: "Geology",
      },
      {
        subject: "German",
        urlSubject: "German",
      },
      {
        subject: "Government and Politics",
        urlSubject: "Government-and-Politics",
      },
      {
        subject: "Graphic Design",
        urlSubject: "Graphic-Design",
      },
      {
        subject: "History",
        urlSubject: "History",
      },
      {
        subject: "History of Art",
        urlSubject: "History-of-Art",
      },
      {
        subject: "Human Biology",
        urlSubject: "Human-Biology",
      },
      {
        subject: "ICT",
        urlSubject: "ICT",
      },
      {
        subject: "Italian",
        urlSubject: "Italian",
      },
      {
        subject: "Japanese",
        urlSubject: "Japanese",
      },
      {
        subject: "Latin",
        urlSubject: "Latin",
      },
      {
        subject: "Law",
        urlSubject: "Law",
      },
      {
        subject: "Mandarin",
        urlSubject: "Mandarin",
      },
      {
        subject: "Maths",
        urlSubject: "Maths",
      },
      {
        subject: "Media Studies",
        urlSubject: "Media-Studies",
      },
      {
        subject: "Music",
        urlSubject: "Music",
      },
      {
        subject: "Philosophy",
        urlSubject: "Philosophy",
      },
      {
        subject: "Philosophy and Ethics",
        urlSubject: "Philosophy-and-Ethics",
      },
      {
        subject: "Physical Education",
        urlSubject: "Physical-Education",
      },
      {
        subject: "Physics",
        urlSubject: "Physics",
      },
      {
        subject: "Polish",
        urlSubject: "Polish",
      },
      {
        subject: "Politics",
        urlSubject: "Politics",
      },
      {
        subject: "Portuguese",
        urlSubject: "Portuguese",
      },
      {
        subject: "Psychology",
        urlSubject: "Psychology",
      },
      {
        subject: "Religious Studies",
        urlSubject: "Religious-Studies",
      },
      {
        subject: "Russian",
        urlSubject: "Russian",
      },
      {
        subject: "Sanskrit",
        urlSubject: "Sanskrit",
      },
      {
        subject: "Science",
        urlSubject: "Science",
      },
      {
        subject: "Sociology",
        urlSubject: "Sociology",
      },
      {
        subject: "Spanish",
        urlSubject: "Spanish",
      },
      {
        subject: "Welsh Literature",
        urlSubject: "Welsh-Literature",
      },
      {
        subject: "Zoology",
        urlSubject: "Zoology",
      },
    ],
  },
  {
    level: "GCSE",
    urlLevel: "GCSE",
    subjects: [
      {
        subject: "Accounting",
        urlSubject: "Accounting",
      },
      {
        subject: "Arabic",
        urlSubject: "Arabic",
      },
      {
        subject: "Art",
        urlSubject: "Art",
      },
      {
        subject: "Biology",
        urlSubject: "Biology",
      },
      {
        subject: "Business Studies",
        urlSubject: "Business-Studies",
      },
      {
        subject: "Career Development",
        urlSubject: "Career-Development",
      },
      {
        subject: "Chemistry",
        urlSubject: "Chemistry",
      },
      {
        subject: "Classical Civilisation",
        urlSubject: "Classical-Civilisation",
      },
      {
        subject: "Classical Greek",
        urlSubject: "Classical-Greek",
      },
      {
        subject: "Computer Science",
        urlSubject: "ComputerScience",
      },
      {
        subject: "Design & Technology",
        urlSubject: "Design-and-Technology",
      },
      {
        subject: "Drama",
        urlSubject: "Drama",
      },
      {
        subject: "Dutch",
        urlSubject: "Dutch",
      },
      {
        subject: "Economics",
        urlSubject: "Economics",
      },
      {
        subject: "Electronics",
        urlSubject: "Electronics",
      },
      {
        subject: "English",
        urlSubject: "English",
      },
      {
        subject: "English and World Literature",
        urlSubject: "English-and-World-Literature",
      },
      {
        subject: "English Language",
        urlSubject: "English-Language",
      },
      {
        subject: "English Literature",
        urlSubject: "English-Literature",
      },
      {
        subject: "Environmental Studies",
        urlSubject: "Environmental-Studies",
      },
      {
        subject: "Extended Project Qualification",
        urlSubject: "EPQ",
      },
      {
        subject: "French",
        urlSubject: "French",
      },
      {
        subject: "Further Mathematics",
        urlSubject: "Further-Maths",
      },
      {
        subject: "Geography",
        urlSubject: "Geography",
      },
      {
        subject: "Geology",
        urlSubject: "Geology",
      },
      {
        subject: "German",
        urlSubject: "German",
      },
      {
        subject: "Government and Politics",
        urlSubject: "Government-and-Politics",
      },
      {
        subject: "Graphic Design",
        urlSubject: "Graphic-Design",
      },
      {
        subject: "History",
        urlSubject: "History",
      },
      {
        subject: "History of Art",
        urlSubject: "History-of-Art",
      },
      {
        subject: "Human Biology",
        urlSubject: "Human-Biology",
      },
      {
        subject: "ICT",
        urlSubject: "ICT",
      },
      {
        subject: "Italian",
        urlSubject: "Italian",
      },
      {
        subject: "Japanese",
        urlSubject: "Japanese",
      },
      {
        subject: "Latin",
        urlSubject: "Latin",
      },
      {
        subject: "Law",
        urlSubject: "Law",
      },
      {
        subject: "Mandarin",
        urlSubject: "Mandarin",
      },
      {
        subject: "Maths",
        urlSubject: "Maths",
      },
      {
        subject: "Media Studies",
        urlSubject: "Media-Studies",
      },
      {
        subject: "Music",
        urlSubject: "Music",
      },
      {
        subject: "Philosophy",
        urlSubject: "Philosophy",
      },
      {
        subject: "Philosophy and Ethics",
        urlSubject: "Philosophy-and-Ethics",
      },
      {
        subject: "Physical Education",
        urlSubject: "Physical-Education",
      },
      {
        subject: "Physics",
        urlSubject: "Physics",
      },
      {
        subject: "Polish",
        urlSubject: "Polish",
      },
      {
        subject: "Politics",
        urlSubject: "Politics",
      },
      {
        subject: "Portuguese",
        urlSubject: "Portuguese",
      },
      {
        subject: "Psychology",
        urlSubject: "Psychology",
      },
      {
        subject: "Religious Studies",
        urlSubject: "Religious-Studies",
      },
      {
        subject: "Russian",
        urlSubject: "Russian",
      },
      {
        subject: "Sanskrit",
        urlSubject: "Sanskrit",
      },
      {
        subject: "Science",
        urlSubject: "Science",
      },
      {
        subject: "Sociology",
        urlSubject: "Sociology",
      },
      {
        subject: "Spanish",
        urlSubject: "Spanish",
      },
      {
        subject: "Zoology",
        urlSubject: "Zoology",
      },
    ],
  },
  {
    level: "University",
    urlLevel: "University",
    subjects: [
      {
        subject: "Accounting",
        urlSubject: "Accounting",
      },
      {
        subject: "Biology",
        urlSubject: "Biology",
      },
      {
        subject: "BMAT (BioMedical Admissions)",
        urlSubject: "BMAT",
      },
      {
        subject: "Business Studies",
        urlSubject: "Business-Studies",
      },
      {
        subject: "Chemical Engineering",
        urlSubject: "ChemicalEngineering",
      },
      {
        subject: "Chemistry",
        urlSubject: "Chemistry",
      },
      {
        subject: "Computer Science",
        urlSubject: "ComputerScience",
      },
      {
        subject: "Economics",
        urlSubject: "Economics",
      },
      {
        subject: "ELAT",
        urlSubject: "ELAT",
      },
      {
        subject: "English",
        urlSubject: "English",
      },
      {
        subject: "French",
        urlSubject: "French",
      },
      {
        subject: "GAMSAT",
        urlSubject: "GAMSAT",
      },
      {
        subject: "Geography",
        urlSubject: "Geography",
      },
      {
        subject: "German",
        urlSubject: "German",
      },
      {
        subject: "HAT",
        urlSubject: "HAT",
      },
      {
        subject: "History",
        urlSubject: "History",
      },
      {
        subject: "Law",
        urlSubject: "Law",
      },
      {
        subject: "LNAT",
        urlSubject: "LNAT",
      },
      {
        subject: "MAT",
        urlSubject: "MAT",
      },
      {
        subject: "Maths",
        urlSubject: "Maths",
      },
      {
        subject: "Medicine",
        urlSubject: "Medicine",
      },
      {
        subject: "MLAT (Modern Languages)",
        urlSubject: "MLAT",
      },
      {
        subject: "Music",
        urlSubject: "Music",
      },
      {
        subject: "PAT",
        urlSubject: "PAT",
      },
      {
        subject: "Philosophy",
        urlSubject: "Philosophy",
      },
      {
        subject: "Physics",
        urlSubject: "Physics",
      },
      {
        subject: "Politics",
        urlSubject: "Politics",
      },
      {
        subject: "Psychology",
        urlSubject: "Psychology",
      },
      {
        subject: "Spanish",
        urlSubject: "Spanish",
      },
      {
        subject: "STEP",
        urlSubject: "STEP",
      },
      {
        subject: "TSA Oxford",
        urlSubject: "TSA-Oxford",
      },
      {
        subject: "UCAT",
        urlSubject: "UCAT",
      },
    ],
  },
  {
    level: "IB",
    urlLevel: "IB",
    subjects: [
      {
        subject: "Arabic",
        urlSubject: "Arabic",
      },
      {
        subject: "Biology",
        urlSubject: "Biology",
      },
      {
        subject: "Business Studies",
        urlSubject: "Business-Studies",
      },
      {
        subject: "Chemistry",
        urlSubject: "Chemistry",
      },
      {
        subject: "Classical Greek",
        urlSubject: "Classical-Greek",
      },
      {
        subject: "Computer Science",
        urlSubject: "ComputerScience",
      },
      {
        subject: "Design & Technology",
        urlSubject: "Design-and-Technology",
      },
      {
        subject: "Drama",
        urlSubject: "Drama",
      },
      {
        subject: "Dutch",
        urlSubject: "Dutch",
      },
      {
        subject: "Economics",
        urlSubject: "Economics",
      },
      {
        subject: "English",
        urlSubject: "English",
      },
      {
        subject: "English and World Literature",
        urlSubject: "English-and-World-Literature",
      },
      {
        subject: "English Language",
        urlSubject: "English-Language",
      },
      {
        subject: "English Literature",
        urlSubject: "English-Literature",
      },
      {
        subject: "Environmental Studies",
        urlSubject: "Environmental-Studies",
      },
      {
        subject: "French",
        urlSubject: "French",
      },
      {
        subject: "Further Mathematics",
        urlSubject: "Further-Maths",
      },
      {
        subject: "Geography",
        urlSubject: "Geography",
      },
      {
        subject: "German",
        urlSubject: "German",
      },
      {
        subject: "Government and Politics",
        urlSubject: "Government-and-Politics",
      },
      {
        subject: "History",
        urlSubject: "History",
      },
      {
        subject: "ICT",
        urlSubject: "ICT",
      },
      {
        subject: "Italian",
        urlSubject: "Italian",
      },
      {
        subject: "Japanese",
        urlSubject: "Japanese",
      },
      {
        subject: "Latin",
        urlSubject: "Latin",
      },
      {
        subject: "Mandarin",
        urlSubject: "Mandarin",
      },
      {
        subject: "Maths",
        urlSubject: "Maths",
      },
      {
        subject: "Music",
        urlSubject: "Music",
      },
      {
        subject: "Philosophy",
        urlSubject: "Philosophy",
      },
      {
        subject: "Physical Education",
        urlSubject: "Physical-Education",
      },
      {
        subject: "Physics",
        urlSubject: "Physics",
      },
      {
        subject: "Politics",
        urlSubject: "Politics",
      },
      {
        subject: "Portuguese",
        urlSubject: "Portuguese",
      },
      {
        subject: "Psychology",
        urlSubject: "Psychology",
      },
      {
        subject: "Religious Studies",
        urlSubject: "Religious-Studies",
      },
      {
        subject: "Russian",
        urlSubject: "Russian",
      },
      {
        subject: "Science",
        urlSubject: "Science",
      },
      {
        subject: "Sociology",
        urlSubject: "Sociology",
      },
      {
        subject: "Spanish",
        urlSubject: "Spanish",
      },
      {
        subject: "Theory of Knowledge",
        urlSubject: "Theory-of-knowledge",
      },
    ],
  },
  {
    level: "KS3",
    urlLevel: "KS3",
    subjects: [
      {
        subject: "Biology",
        urlSubject: "Biology",
      },
      {
        subject: "Chemistry",
        urlSubject: "Chemistry",
      },
      {
        subject: "English",
        urlSubject: "English",
      },
      {
        subject: "English Language",
        urlSubject: "English-Language",
      },
      {
        subject: "English Literature",
        urlSubject: "English-Literature",
      },
      {
        subject: "French",
        urlSubject: "French",
      },
      {
        subject: "History",
        urlSubject: "History",
      },
      {
        subject: "Maths",
        urlSubject: "Maths",
      },
      {
        subject: "Physics",
        urlSubject: "Physics",
      },
      {
        subject: "Science",
        urlSubject: "Science",
      },
      {
        subject: "Spanish",
        urlSubject: "Spanish",
      },
    ],
  },
  {
    level: "National 4 and 5",
    urlLevel: "National-4-and-5",
    subjects: [
      {
        subject: "Biology",
        urlSubject: "Biology",
      },
      {
        subject: "Chemistry",
        urlSubject: "Chemistry",
      },
      {
        subject: "Computer Science",
        urlSubject: "ComputerScience",
      },
      {
        subject: "English",
        urlSubject: "English",
      },
      {
        subject: "English Language",
        urlSubject: "English-Language",
      },
      {
        subject: "English Literature",
        urlSubject: "English-Literature",
      },
      {
        subject: "Maths",
        urlSubject: "Maths",
      },
      {
        subject: "Physics",
        urlSubject: "Physics",
      },
      {
        subject: "Science",
        urlSubject: "Science",
      },
    ],
  },
  {
    level: "Scottish Highers",
    urlLevel: "Scottish-Highers",
    subjects: [
      {
        subject: "Biology",
        urlSubject: "Biology",
      },
      {
        subject: "Chemistry",
        urlSubject: "Chemistry",
      },
      {
        subject: "Computer Science",
        urlSubject: "ComputerScience",
      },
      {
        subject: "Economics",
        urlSubject: "Economics",
      },
      {
        subject: "English",
        urlSubject: "English",
      },
      {
        subject: "English Language",
        urlSubject: "English-Language",
      },
      {
        subject: "English Literature",
        urlSubject: "English-Literature",
      },
      {
        subject: "French",
        urlSubject: "French",
      },
      {
        subject: "Geography",
        urlSubject: "Geography",
      },
      {
        subject: "German",
        urlSubject: "German",
      },
      {
        subject: "History",
        urlSubject: "History",
      },
      {
        subject: "Human Biology",
        urlSubject: "Human-Biology",
      },
      {
        subject: "Maths",
        urlSubject: "Maths",
      },
      {
        subject: "Physics",
        urlSubject: "Physics",
      },
      {
        subject: "Psychology",
        urlSubject: "Psychology",
      },
    ],
  },
  {
    level: "Mentoring",
    urlLevel: "Mentoring",
    subjects: [
      {
        subject: "Career Development",
        urlSubject: "Career-Development",
      },
      {
        subject: "Medical School Preparation",
        urlSubject: "Medical-School-Preparation",
      },
      {
        subject: "Oxbridge Preparation",
        urlSubject: "Oxbridge-Preparation",
      },
      {
        subject: "Personal Statements",
        urlSubject: "Personal-Statement-Service",
      },
      {
        subject: "Python",
        urlSubject: "Python",
      },
    ],
  },
  {
    level: "13 Plus",
    urlLevel: "13-Plus",
    subjects: [
      {
        subject: "Classical Greek",
        urlSubject: "Classical-Greek",
      },
      {
        subject: "English",
        urlSubject: "English",
      },
      {
        subject: "French",
        urlSubject: "French",
      },
      {
        subject: "Geography",
        urlSubject: "Geography",
      },
      {
        subject: "German",
        urlSubject: "German",
      },
      {
        subject: "History",
        urlSubject: "History",
      },
      {
        subject: "Latin",
        urlSubject: "Latin",
      },
      {
        subject: "Mandarin",
        urlSubject: "Mandarin",
      },
      {
        subject: "Maths",
        urlSubject: "Maths",
      },
      {
        subject: "Religious Studies",
        urlSubject: "Religious-Studies",
      },
      {
        subject: "Science",
        urlSubject: "Science",
      },
      {
        subject: "Spanish",
        urlSubject: "Spanish",
      },
    ],
  },
  {
    level: "11 Plus",
    urlLevel: "11-plus",
    subjects: [
      {
        subject: "English",
        urlSubject: "English",
      },
      {
        subject: "Maths",
        urlSubject: "Maths",
      },
      {
        subject: "Spanish",
        urlSubject: "Spanish",
      },
    ],
  },
  {
    level: "KS2",
    urlLevel: "KS2",
    subjects: [
      {
        subject: "English",
        urlSubject: "English",
      },
      {
        subject: "Maths",
        urlSubject: "Maths",
      },
      {
        subject: "Science",
        urlSubject: "Science",
      },
      {
        subject: "Spanish",
        urlSubject: "Spanish",
      },
    ],
  },
];
